import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=8b6050d8&scoped=true"
import script from "./CheckForm.vue?vue&type=script&lang=js"
export * from "./CheckForm.vue?vue&type=script&lang=js"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=8b6050d8&prod&scoped=true&lang=less"
import style1 from "./CheckForm.vue?vue&type=style&index=1&id=8b6050d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6050d8",
  null
  
)

export default component.exports